import { provideComboboxConfig } from 'ng-primitives/combobox';
import { provideDatePickerConfig } from 'ng-primitives/date-picker';
import { NgpNativeDateAdapter, provideDateAdapter } from 'ng-primitives/date-time';
import { provideToastConfig } from 'ng-primitives/toast';
import { provideTooltipConfig } from 'ng-primitives/tooltip';

export function providePrimitives() {
  return [
    provideDateAdapter(NgpNativeDateAdapter),
    provideDatePickerConfig({ firstDayOfWeek: 1 }),
    provideToastConfig({
      ariaLive: 'assertive',
      dismissible: true,
      duration: 5_000,
      gap: 16,
      maxToasts: 3,
      placement: 'top-center',
      offsetTop: 60,
      swipeDirections: ['left', 'right'],
    }),
    provideTooltipConfig({
      offset: 9,
      placement: 'top',
      showDelay: 0,
      hideDelay: 500,
      flip: true,
      container: document.body,
      showOnOverflow: false,
      useTextContent: true,
    }),
    provideComboboxConfig({
      placement: 'bottom',
      flip: true,
    }),
  ];
}
